import Vue from "vue"
import VueRouter, {Route} from "vue-router"

Vue.use(VueRouter)

export const router = new VueRouter({
  mode: "history",
  linkExactActiveClass: "selected",
  // eslint-disable-next-line @typescript-eslint/promise-function-async
  scrollBehavior: (to, from) => {
    if (from.meta.restoreScrollPosition === true) {
      from.meta.scrollPosition = {
        x: window.scrollX,
        y: window.scrollY,
      }
    } else if (to.meta.restoreScrollPosition === true) {
      return new Promise(resolve => {
        // This doesn't always work because
        // of the transitions
        setTimeout(() => {
          resolve(to.meta.scrollPosition)
        })
      })
    }

    // Default behaviour is to scroll to
    // the top
    return {x: 0, y: 0}
  },
})

let redirectPath: string | null = null

router.beforeEach((to: Route, from: Route, next: any) => {
  const app: any = router.app

  const isAuthenticated = app.isAuthenticated

  console.log("Before navigation:", router.app, to, from)
  console.log("Before navigation redirect path:", redirectPath)

  console.log("Before navigation isAuthenticated:", isAuthenticated)

  console.log("To meta:", to.meta)

  if (<boolean>to.meta.unauthenticatedAccess) {
    console.log("Navigating to:", to)

    if (to.fullPath === redirectPath) {
      console.log("Resetting redirect path", redirectPath)
      redirectPath = null
    }

    next()
  } else if (isAuthenticated === true) {
    // This is needed to make sure api authentication is valid/current
    app.isApiAuthenticated()

    if (to.path === "/!redirect") {
      // Should retain the query when navigating to root, the query is
      // propagated as part of the redirect
      const goTo = redirectPath == null ? {path: "/", query: from.query} : redirectPath
      console.log("Redirecting to/from", goTo, from)
      redirectPath = null
      next(goTo)
    } else {
      next()
    }
  } else {
    // Always store the redirect path because it can't rely on
    // meta.unauthenticatedAccess only since some urls like the i.e. the modals
    // are not in the router

    redirectPath = to.fullPath
    console.log("Storing redirect path", redirectPath)

    if (isAuthenticated == null) {
      // Authentication undefined means the application is being loaded and it
      // can't tell whether is authenticated or not yet, so it sends it to the
      // route so it will try to load data in order to figure. This is
      // necessary for page reloads to work correctly.
      console.log("Application being loaded, no authentication info, navigating to", to)
      next()
    } else {
      // isAuthenticated === false
      next("/login")
    }
  }
})

// TODO Enable tracking
// router.afterEach((to: Route, from: Route) => {
//   const app = <any>router.app
//
//   if (app.isAuthenticated === true) {
//     track(to, from, app)
//   }
// })
//
// const track = (to: Route, from: Route, app: any) => {
//
//   const navigation = {path: to.fullPath, referrerPath: from.fullPath}
//   app.trackingService
//     .track(navigation)
//     .catch((error: any) =>
//       console.error("Unable to record navigation:", navigation, error)
//     )
// }
